import React, { Suspense } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Button } from "@ai-content-hub/content-kit";
import { Play, Home } from "lucide-react";
import { RouteFallback } from "../components/common";

export const PlayerLayout: React.FC = () => {
    const location = useLocation();

    return (
        <div className="min-h-screen bg-background">
            {/* Header */}
            <header className="sticky top-0 z-50 w-full border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
                <div className="container flex h-16 items-center justify-between px-4">
                    <div className="flex items-center gap-6">
                        <Link to="/play" className="flex items-center gap-2">
                            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-success text-success-foreground">
                                <Play className="h-5 w-5" />
                            </div>
                            <span className="text-xl font-bold font-heading">
                                Content Player
                            </span>
                        </Link>
                    </div>

                    <nav className="flex items-center gap-2">
                        <Link to="/play">
                            <Button
                                variant={location.pathname === "/play" ? "default" : "ghost"}
                                size="sm"
                            >
                                <Home className="h-4 w-4 mr-2" />
                                Demo
                            </Button>
                        </Link>
                        <Link to="/">
                            <Button
                                variant="ghost"
                                size="sm"
                            >
                                Editor
                            </Button>
                        </Link>
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="container py-8 px-4">
                {/* EAA-1670: inner Suspense keeps the player header mounted while the
                    next lazy page chunk downloads. */}
                <Suspense fallback={<RouteFallback />}>
                    <Outlet />
                </Suspense>
            </main>
        </div>
    );
};

export default PlayerLayout;

